import { useState } from 'react'
import {
  ModalContainer,
  ModalContent,
  ModalRoot,
} from 'src/components/ui/modal'
import newPixIcon from '../../../../assets/newPixIcon.svg'
import { LinkOption } from '../../../../components/LinkOptions'
import { NewPixForm } from './NewPixForm'

export function NewPix() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  function handleOpenModal() {
    setIsModalOpen((prev) => !prev)
  }

  return (
    <div>
      <LinkOption title="Pix" icon={newPixIcon} onClick={handleOpenModal} />
      <ModalRoot open={isModalOpen} setIsOpen={setIsModalOpen}>
        <ModalContainer>
          <ModalContent>
            <NewPixForm />
          </ModalContent>
        </ModalContainer>
      </ModalRoot>
    </div>
  )
}
